import type { ICartItem } from '../hooks/useCart';
import type { II18nLanguageObj } from '../hooks/useLanguage';

interface BlockCount {
    ticketTypeId?: number;
    ticketTypeName?: string;
    available?: number;
}

export function computeTicketStatuses(
    cart: ICartItem[],
    blocks: BlockCount[],
    forceSoldOutStatus: boolean,
    getI18n: (primary: string, i18n?: II18nLanguageObj) => string,
) {
    const remainingByType = new Map<number, number>();
    for (const block of blocks) {
        if (block.ticketTypeId != null) {
            remainingByType.set(block.ticketTypeId, block.available ?? 0);
        }
    }

    const mapped = cart.map((ticket) => {
        const requestedQuantity = ticket.quantity || 1;
        let status: 'available' | 'soldOut' = 'available';

        const remaining = remainingByType.get(ticket.ticketTypeId);
        if (remaining !== undefined) {
            if (remaining >= requestedQuantity) {
                remainingByType.set(ticket.ticketTypeId, remaining - requestedQuantity);
            } else {
                status = 'soldOut';
                remainingByType.set(ticket.ticketTypeId, 0);
            }
        }

        return {
            key: `${ticket.ticketTypeId}-${ticket.ticketOptionId}`,
            status,
            quantity: requestedQuantity,
            ticketName: `${getI18n(ticket.ticketTypeName, ticket.ticketTypeNameI18n)} ${getI18n(ticket.ticketOptionName, ticket.ticketOptionNameI18n)}`,
        };
    });

    const hasSoldOut = mapped.some((item) => item.status === 'soldOut');
    if (!hasSoldOut && forceSoldOutStatus && mapped.length > 0) {
        return mapped.map((item, index) =>
            index === mapped.length - 1 ? { ...item, status: 'soldOut' as const } : item,
        );
    }

    return mapped;
}
